import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  updateList,
  sendRequest,
  selectQueryParams
} from '../../../../../../common/reducers/list/reducer';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import EventsUserNoticeService from '../../../../services/EventsUserNoticeService';
import { insertUpdateItems as insertUpdateObjectCollectionItems } from '../../../../../../common/reducers/objectCollection/reducer';

function* eventsUserNoticesListSaga(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  let status = null;
  try {
    const result = yield call(
      timeoutCall,
      EventsUserNoticeService.getMe,
      queryParams
    );
    if (result.response) {
      status = result.response.status;
      if (result.response.status) {
        yield put(
          insertUpdateObjectCollectionItems(
            'eventsModule.collections.eventsUserNoticesCollection',
            result.destructData.itemsById
          )
        );
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds,
            pagination: result.destructData.pagination
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeLatest(
      sendRequest(reducerName).type,
      eventsUserNoticesListSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/lists/sagas/eventsUserNoticesListSaga.js